import React, { Component } from 'react'
import ConsumedPieChart from './ConsumedPieChart';

export default class PieStack extends Component {
  constructor(props) {
    super(props);
    this.state = {
      charts: null,
    }
  }

  componentDidMount() {
    const du = this.distinctUnits(this.props.report)
    let groups = new Array(du.length);
    for (let i= 0; i<du.length; i++) {
      groups[i] = this.groupBy(du[i].units1, this.props.report)
    }
     this.setState ({charts: groups})
  }
  distinctUnits (arrData) {
    return arrData.filter((x, index, self) => self.findIndex(y => y?.units1 === x?.units1) === index)
  }
  groupBy(unit, allData) {
    return allData.filter(x => x?.units1 === unit)
  }

  render() {
    if (this.state.charts) {
      console.log (this.state.charts)
      return (
        this.state.charts.map((group, index) => (
         <ConsumedPieChart key={index} {...this.props} report={group} />
        ))
      )
    } 
    return null;
  }
}

